import React from "react";
import { connect } from "react-redux";
import { MetypeCommentingWidget } from "@metype/components";
import { generateHostStoryUrl } from "../utils/generate-story-url";
import get from "lodash/get";
import PropTypes from "prop-types";

function MetypeCommentWrapperBase({ publisherAttributes = {}, story }) {
  return (
    <div className="metype-comments-container">
      <MetypeCommentingWidget
        host={publisherAttributes["metypeHost"]}
        accountId={publisherAttributes["metypeAccountId"]}
        pageURL={generateHostStoryUrl(story)}
        primaryColor={publisherAttributes["primaryColor"]}
        className={publisherAttributes["className"]}
      />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"])
  };
}

export const MetypeCommentWrapper = connect(
  mapStateToProps,
  null
)(MetypeCommentWrapperBase);

MetypeCommentWrapperBase.propTypes = {
  publisherAttributes: PropTypes.object,
  metypeConfig: PropTypes.object,
  story: PropTypes.object
};
